module.exports = __webpack_public_path__ + "static/media/AYA LAILA.5f385c42.png";